import { sendRequestJson } from "@/utils";
import { apiRequest } from "@/utils/apiRequest";
import { apiUrl } from "@/utils/apiUrl";

class VenueRepository {
	constructor() {
		const host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	async getVenueConfigOld() {
		const url = this.urlBase + "/world/api/venueconfig";
		try {
			return await sendRequestJson({ data: {}, url, method: "POST" }, false);
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo la información de la venue.");
		}
	}

	async getVenueConfig() {
		const { data, status } = await apiRequest({
			url: apiUrl("/world/api/venueconfig"), // absolute or relative
			method: "POST", // keep POST until the backend changes
			body: null, // explicit: no content
			token: null, // skip Authorization header (like “false” before)
			expect: "json", // default, but explicit is clearer
			throwOnNonOk: false,
		});

		if (status !== 200) {
			// Convert “unexpected HTTP” → typed Error that carries details
			const err = new Error(data?.message || `HTTP ${status}`);
			err.status = status; // numeric 404, 423, …
			err.data = data; // { error:'INVALID_VENUE', … }  (may be undefined)
			throw err; // bubbles up to store
		}

		return data;
	}

	async getElaborationTypes() {
		const { data, status } = await apiRequest({
			url: apiUrl("/world/api/elaborationtype/get"), // absolute or relative
			method: "POST", // keep POST until the backend changes
			body: null, // explicit: no content
			token: null, // skip Authorization header (like “false” before)
			expect: "json", // default, but explicit is clearer
			throwOnNonOk: false,
		});

		if (status !== 200) {
			// Convert “unexpected HTTP” → typed Error that carries details
			const err = new Error(data?.message || `HTTP ${status}`);
			err.status = status; // numeric 404, 423, …
			err.data = data; // { error:'INVALID_VENUE', … }  (may be undefined)
			throw err; // bubbles up to store
		}

		return data;

		/*const url = this.urlBase + "/world/api/elaborationtype/get"
		try {
			return await sendRequestJson({data: {}, url, method: "POST"}, false);
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo los elaborationTypes.");
		}*/
	}

	async getTables(venueId) {
		const url =this.urlBase + `/world/api/venue/${venueId}/rooms?includeTables=1`;
		try {
			return await apiRequest({
				method: "GET",
				url: url,
			});
		} catch (e) {
			console.log("Ups, algo ha ido mal comprobando la disponibilidad.", e);
		}
	}

	async getVenueMenus() {
		const url = this.urlBase + "/world/api/venuemenus";
		try {
			return await sendRequestJson({ data: {}, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo los menus de la venue.");
		}
	}
}

export const venueRepository = new VenueRepository();
